import { Modal } from "antd";
import CustomerLink from "../../shared/CustomerLink";
import { IoChevronBackCircleSharp } from "react-icons/io5";

const GiftCardDetail = ({ record, open, setOpen }) => {
  return (
    <Modal title="" open={open} footer={null} onCancel={() => setOpen(false)}>
      <h2 className="font-bold text-[20px] text-center line-[32px]">Transaction details</h2>
      <div className="flex justify-center items-center">
      <IoChevronBackCircleSharp color="green" size={25} />
      </div>
      <p className="text-[18px] text-center font-[500]">Purchased USD {record?.amount} {record?.metadata?.receiptType}</p>
      <p className="text-[12px] text-center text-[#787389]">
        {new Date(record.createdAt).toLocaleDateString()}{" "}{new Date(record.createdAt).toLocaleTimeString()}
      </p>

      <div className="flex justify-between mt-5">
        <p>Customer</p>
        <CustomerLink record={record} />
      </div>

      <div className="flex justify-between mt-2 mb-2">
        <p>Status</p>
        <p className="capitalize">{record.status}</p>
      </div>

      {record?.metadata?.admin &&
      <div className="flex justify-between mt-2 mb-2">
        <p>Processed By</p>
        <p className="capitalize">{record?.metadata?.admin?.firstName} {record?.metadata?.admin?.lastName }</p>
      </div>
      }

      <hr />

      <div className="flex justify-between mt-5">
        <p>Quantity</p>
        <p>{record.metadata?.quantity}</p>
      </div>

      <div className="flex justify-between mt-2">
        <p>Country</p>
        <p className="capitalize">{record?.metadata?.country}</p>
      </div>

      <div className="flex justify-between mt-2">
        <p>Category</p>
        <p>{record?.metadata?.category}</p>
      </div>
      <div className="flex justify-between mt-2">
        <p>Transaction feed</p>
        <p>{Number(record?.amount).toLocaleString()}</p>
      </div>
      {record?.metadata?.rate &&
      <div className="flex justify-between mt-2">
        <p>Rate</p>
        <p>NGN {Number(record?.metadata?.rate || 0).toLocaleString()}</p>
      </div>
      }
      
      <div className="flex justify-between mt-2">
        <p>Payment method</p>
        <p>{record?.paymentMethod}</p>
      </div>
      <div className="flex justify-between mt-2">
        <p>Order ID</p>
        <p>{record?._id}</p>
      </div>
      {record?.metadata?.imageURL &&
      <div className="flex justify-between mt-2">
        <p>Card</p>
        <img src={record.metadata.imageURL} className="h-[150px] w-[150px]" alt="car" />
      </div>
      }

      {record?.metadata?.note &&
      <div className="flex justify-between mt-2">
        <p>Note</p>
        <p>{record?.metadata?.note}</p>
      </div>
      }
    </Modal>
  );
};

export default GiftCardDetail;
